/**
 * @enum WinTrigger - Type which triggers win
 */
export enum WinTrigger {
    /**
     * @member payline - payline triggers win.
     */
    Payline = <any>'payline',

    /**
     * @member scatter - scatter triggers win.
     */
    Scatter = <any>'scatter',

    /**
     * @member custom - custom logic triggers win.
     */
    Custom = <any>'custom',

    /**
     * @member way - way trigger win.
     */
    Way = <any>'way'
}


/** WEBPACK FOOTER **
 ** ./Engine/Communication/Game/Types/WinTrigger.ts
 **/